const Spacer = ({ y }: { y: number }) => <div style={{ marginBottom: `${y}px` }} />;

export default Spacer;
